import React, {
  useContext, useState, useCallback,
} from 'react';
import { Context } from '../../../stateManagement/store';
import useActionsHook from '../../../stateManagement/actions';
import { WALLET_TYPES, TREZOR_PATHS } from '../../../constants/wallet';
import { getTrezorAccount } from '../../../services/trezorService';
import Warning from './Warning';
import Accounts from '../Common/Accounts';
import '../Common/styles.scss';
import '../Common/Warning.scss';
import CloseIcon from '../../Icons/CloseIcon';
import TrezorIcon from '../../Icons/ProviderIcons/TrezorIcon';
import DerivationPath from './DerivationPath';
import {IHDWalletProps} from "../../../interfaces";

const STEPS = {
  WARNING: 0,
  DERIVATION_PATH: 1,
  ACCOUNTS: 2,
};

const Trezor: React.FC<IHDWalletProps> = ({ afterConnect }) => {
  const { dispatch, state } = useContext(Context);
  const actions = useActionsHook(dispatch);
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [derivationPath, setDerivationPath] = useState(TREZOR_PATHS.LIVE.value);
  // const [step, setStep] = useState(STEPS.ACCOUNTS);
  const [step, setStep] = useState(STEPS.WARNING);

  const onWarningConfirm = useCallback(() => setStep(STEPS.ACCOUNTS), []);
  const onAdvancedClick = useCallback(() => setStep(STEPS.DERIVATION_PATH), []);

  const onClose = useCallback(() => {
    actions.closeTrezorFunnel();
  }, [actions]);

  const onModeSelect = useCallback((path) => {
    setDerivationPath(path);
    setStep(STEPS.ACCOUNTS);
  }, []);

  const loadMoreAccounts = useCallback(async () => {
    if (!loading) {
      setLoading(true);
      setError(undefined);
      try {
        const nextAccounts = await getTrezorAccount(offset, derivationPath);
        setAccounts([...accounts, ...nextAccounts]);
        setOffset(offset + 5);
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    }
  }, [offset, accounts, loading, derivationPath]);

  const onConfirmAddress = useCallback(async (index, savePath) => {
    if (!accounts.length) {
      onClose();
    }
    await actions.connectWallet({
      connectionType: WALLET_TYPES.trezor, ...(state.network || {}), trezorPath: derivationPath.replace('x', index), savePath,
    });
    afterConnect();
  }, [onClose, actions, state.network, accounts, derivationPath, afterConnect]);

  const { connectingWallet, connectionError } = state;

  return (
    <div className="web3-wc_hd-wallet trezor">
      <CloseIcon className="web3-wc_close-modal-btn ledger web3-wc_modal-icon-btn" onClick={onClose}>X</CloseIcon>
      <div className="web3-wc_hd-wallet-icon">
        <TrezorIcon />
      </div>
      {step === STEPS.WARNING && <Warning onClick={onWarningConfirm} onAdvancedClick={onAdvancedClick} />}
      {step === STEPS.DERIVATION_PATH && <DerivationPath onConfirm={onModeSelect} />}
      {step === STEPS.ACCOUNTS && (
        <Accounts
          walletName="Trezor"
          onConfirm={onConfirmAddress}
          accounts={accounts}
          loading={loading}
          loadMoreAccounts={loadMoreAccounts}
          connecting={connectingWallet}
          connectionError={connectionError}
          error={error}
        />
      )}
    </div>
  );
};

export default Trezor;
